<template>
  <form class="form" @submit.prevent>
    <div ref="title" class="form__title">
      <transition-group name="fade">
        <div v-for="(title,i) in steptitles" :key="i  + ' ' + title"><h2 :id="`step${step}-title`" v-show="step == i">{{title}}</h2></div>
      </transition-group>
    </div>
    <div class="form__content">
      <div class="form__window" :style="shift">
        <div class="form__slides">
          <Step0 class="form__step"/>
          <Step1 class="form__step"/>
          <Step2 class="form__step"/>
          <Step3 class="form__step"/>
          <Step4 class="form__step"/>
          <Step5 class="form__step"/>
          <Step6 class="form__step"/>
          <Step7 class="form__step"/>
          <Step8 class="form__step"/>
          <Step9 class="form__step"/>
          <Step10 class="form__step"/>
          <Step11 class="form__step"/>
          <Step12 class="form__step"/>
          <Step13 class="form__step"/>
          <Step14 :cob="1" class="form__step"/>
          <CoborrowerStep :cob="1" :number="15" v-if="enabledcobs" class="form__step"/>
          <Step3 prefix="coborrower1" :number="16" v-if="enabledcobs" class="form__step"/>
          <Step4 prefix="coborrower1" :number="17" v-if="enabledcobs" class="form__step"/>
          <Step5 prefix="coborrower1" :number="18" v-if="enabledcobs" class="form__step"/>
          <Step10 postfix="coborrower1" :number="19" v-if="enabledcobs" class="form__step"/>
          <Step11 postfix="coborrower1" :number="20" v-if="enabledcobs" class="form__step"/>
          <Step12 postfix="coborrower1" :number="21" :sexstepnumber="16" v-if="enabledcobs" class="form__step"/>
          <Step14 :cob="2" :number="22" class="form__step" v-if="enabledcobs"/>
          <CoborrowerStep :cob="2" :number="23" v-if="enabledcobs > 1" class="form__step"/>
          <Step3 prefix="coborrower2" :number="24" v-if="enabledcobs > 1" class="form__step"/>
          <Step4 prefix="coborrower2" :number="25" v-if="enabledcobs > 1" class="form__step"/>
          <Step5 prefix="coborrower2" :number="26" v-if="enabledcobs > 1" class="form__step"/>
          <Step10 postfix="coborrower2" :number="27" v-if="enabledcobs > 1" class="form__step"/>
          <Step11 postfix="coborrower2" :number="28" v-if="enabledcobs > 1" class="form__step"/>
          <Step12 postfix="coborrower2" :number="29" :sexstepnumber="24" v-if="enabledcobs > 1" class="form__step"/>
          <Step14 :cob="3" :number="30" class="form__step" v-if="enabledcobs > 1"/>
          <CoborrowerStep :cob="3" :number="31" v-if="enabledcobs > 2" class="form__step"/>
          <Step3 prefix="coborrower3" :number="32" v-if="enabledcobs > 2" class="form__step"/>
          <Step4 prefix="coborrower3" :number="33" v-if="enabledcobs > 2" class="form__step"/>
          <Step5 prefix="coborrower3" :number="34" v-if="enabledcobs > 2" class="form__step"/>
          <Step10 postfix="coborrower3" :number="35" v-if="enabledcobs > 2" class="form__step"/>
          <Step11 postfix="coborrower3" :number="36" v-if="enabledcobs > 2" class="form__step"/>
          <Step12 postfix="coborrower3" :number="37" :sexstepnumber="32" v-if="enabledcobs > 2" class="form__step"/>
          <LastStep class="form__step" :number="15 + enabledcobs * 8 - (enabledcobs == 3? 1 : 0)"/>
        </div>
      </div>
    </div>
    <ErrorMessage v-model="errorMessage" />
    <SuccessMessage v-model="successMessage" />
    <LoadingScreen v-model="loading" />
  </form>
</template>

<script>
import smoothHeight from 'vue-smooth-height'
import { mapState, mapGetters } from 'vuex'
import ErrorMessage from './ErrorMessage.vue'
import LoadingScreen from './LoadingScreen.vue'
import SuccessMessage from './SuccessMessage.vue'
import Step0 from './Step0.vue'
import Step1 from './Step1.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Step6 from './Step6.vue'
import Step7 from './Step7.vue'
import Step8 from './Step8.vue'
import Step9 from './Step9.vue'
import Step10 from './Step10.vue'
import Step11 from './Step11.vue'
import Step12 from './Step12.vue'
import Step13 from './Step13.vue'
import Step14 from './Step14.vue'
import LastStep from './LastStep.vue'
import CoborrowerStep from './CoborrowerStep.vue'

export default {
  data: ()=>({
    enabledcobs: 0
  }),
  components: { ErrorMessage, LoadingScreen, SuccessMessage, Step0, Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9, Step10, Step11, Step12, Step13, Step14, LastStep, CoborrowerStep },
  props:{
    step: {type: Number, required: true}
  },
  mixins: [smoothHeight],
  created(){
    fetch('https://raw.githubusercontent.com/umpirsky/country-list/master/data/ru_RU/country.json', {
      method: 'GET'
    }).then(response => response.json())
      .then(json =>{
        let countries = Object.values(json)
        for (let i = 0; i < countries.length; i++)
          if (countries[i] == 'Россия') {
            countries[i] = countries[0]
            countries[0] = 'Россия'
            break;
          }
        this.$store.commit('setCountryList', countries)
      })
      .catch(()=>this.$store.dispatch('throwDefaultError'))
  },
  mounted(){
    this.$smoothElement({
      el: this.$el,
      transition: 'height .5s'
    }) 
    this.$store.commit('setFormEl', this.$el)
    let savedData = localStorage.getItem('data')
    if (savedData) 
      this.$store.dispatch('throwSuccess', {
        title: 'Помощь',
        text: 'Мы заметили сохранённые данные на вашем устройстве. Хотите заполнить форму сохранёнными данными?<br><br>P.S: В целях безопасности, файлы не будут заполнены!',
        type: 'load'
      })      
  },
  computed: {
    shift(){
      return `transform: translateX(${(- this.step) * 100}%)`
    },
    ...mapState(['loading','stepsdata']),
    ...mapGetters(['stepcount', 'steptitles', 'cobscount']),
    errorMessage: {
      get () { return this.$store.state.errorMessage},
      set (value) { this.$store.commit('setError', value) }
    },
    successMessage: {
      get () { return this.$store.state.successMessage},
      set (value) { this.$store.commit('setSuccess', value) }
   }
  },
  methods:{
    translateCobCount(count) {
      if (!count) return 0
      return count * 8 - (count == 3?1:0)
    },
  },
  watch: {
    cobscount(val){
      if (val == this.enabledcobs) return
      let need = this.translateCobCount(val), has = this.translateCobCount(this.enabledcobs)
      let diff = need - has
      if (diff > 0)
        this.$store.commit('addSlidesData', diff)
      if (diff < 0)
        this.$store.commit('removeSlidesData', diff * -1)
      this.enabledcobs = val

    },
    step(v){
      if(v) {
        this.$store.dispatch('metrikaAction', `dalee_${v}`)
      }
      window.scrollTo({
        top: this.$refs.title.getBoundingClientRect().top + document.documentElement.scrollTop,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style lang="sass">
.mb0
  margin-bottom: 0 !important
.form
  --basespace: 32px
  --labelspace: 32px
  --bgcolor: #{colors.$bg}
  position: relative
  z-index: 1
  align-self: flex-start
  padding: 64px 0
  background: var(--bgcolor)
  box-shadow: 0px 20px 40px rgba(34, 64, 92, 0.1)
  &__content
    width: 100%
    overflow: hidden
  &__text
    font-size: 14px
    line-height: 24px
    color: colors.$gray
  .form__text.form__text_smspace + *
    padding-top: 16px
  div.form__title
    position: absolute
    bottom: 100%
    left: 0
    width: 100%
    height: var(--titleheight)
    span
      position: absolute
      top: 0
      left: 0
      width: 100%
    h2
      color: colors.$red
      font-weight: bold
      font-size: 28px
      line-height: 34px
    @include for-mob
      position: relative
      left: 30px
      right: initial
      bottom: initial
      top: initial
      width: calc(100% - 60px)
      height: auto
      margin-bottom: var(--basespace)
      display: flex
      h2
        font-size: 26px
      span
        position: static
        display: block
        width: 100%
        &:not(::last-child)
          margin-right: -100%
    @include from(480px)
      left: 20px
      width: calc(100% - 40px)

  h3.form__title, h4.form__title
    color: colors.$brown
    font-weight: 500
    font-size: 20px
    line-height: 32px
  &__window
    width: 100%
    transition: transform .4s ease-out
  &__slides
    display: flex
    align-items: flex-start
    overflow: visible
    width: 100%
  &__step
    overflow: visible
    background: var(--bgcolor)
    width: 100%
    min-width: 100%
    padding: 0 106px
    transition: opacity .5s ease
    &_hidden
      opacity: 0
      pointer-events: none
      max-height: 0
  & &__btns
    padding-top: 64px
    display: flex
    justify-content: space-between
    button:first-child:last-child
      margin-left: auto
  &__legend
    padding-top: 2px
    margin-bottom: 34px
    color: colors.$brown
    font-weight: 500
    font-size: 20px
    line-height: 30px
  h2.form__legend
    margin-bottom: 30px
  &__space
    margin-bottom: 60px
  &__assessment
    display: flex
    margin-bottom: 10px
    >*:first-child
      align-self: flex-start
      margin-right: 24px
  &__dl
    dt
      font-size: 16px
      line-height: 26px
      color: colors.$brown
      margin-bottom: 6px
    dd
      margin: 0
      font-size: 13px
      line-height: 18px
      color: colors.$gray
</style>